/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';

export const knowledgeFiles = (state) => state?.pieve?.knowledgeFiles || EMPTY_ARRAY;
